import { render } from "./EmployeeComponent.vue?vue&type=template&id=18da8fca"
import script from "./EmployeeComponent.vue?vue&type=script&lang=js"
export * from "./EmployeeComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/employees/EmployeeComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18da8fca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18da8fca', __exports__)) {
    api.reload('18da8fca', __exports__)
  }
  
  module.hot.accept("./EmployeeComponent.vue?vue&type=template&id=18da8fca", () => {
    api.rerender('18da8fca', render)
  })

}


export default __exports__